'use-client';
import React, { forwardRef } from 'react';
import classNames from 'clsx';
import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import { getComponentProps } from '@wix/thunderbolt-elements/src/components/ConsentPolicyWrapper/viewer/utils';
import type {
  GoogleMapReactProps,
  IGoogleMapsImperativeActions,
} from '../GoogleMap.types';

import semanticClassNames from '../GoogleMap.semanticClassNames';
import style from './style/GoogleMapReact.module.scss';

const GoogleMapReact = forwardRef<
  IGoogleMapsImperativeActions,
  GoogleMapReactProps
>((props, forwardedRef) => {
  const {
    id,
    className,
    skin,
    customClassNames = [],
    isConsentPolicyActive,
    translations,
    lang,
    onMouseEnter,
    onMouseLeave,
    MapContent,
  } = props;

  const domSafeProps = {
    id,
    className: classNames(
      style[skin],
      className,
      formatClassNames(semanticClassNames.root, ...customClassNames),
    ),
    ...getDataAttributes(props),
    lang,
  };

  const baseComponentProps = getComponentProps(
    isConsentPolicyActive,
    domSafeProps,
  );

  return (
    <div
      {...baseComponentProps}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        className={style.mapContainer}
        aria-label={translations.title}
        role="region"
      >
        <MapContent {...props} ref={forwardedRef} />
      </div>
    </div>
  );
});

export default GoogleMapReact;
